// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CheckboxButton_wrapper__B1J3W","error":"CheckboxButton_error__ExMJL","labelWrapper":"CheckboxButton_labelWrapper__f8MH_"};